import type { User } from '@halo/chat-sdk';
import { useAppStore } from '@halo/chat-sdk-react';
import { isEmpty, take, filter } from 'lodash/fp';
import { GroupeContacts } from './ResultContacts';

function Contacts() {
  const { t } = useTranslation();
  const [contacts, setContacts] = useState<User[]>();
  const { client, user } = useAppStore();

  const getContacts = useCallback(async () => {
    const { users } = (await client?.Api.contacts.contactsSearchByKeyInLocal('')) ?? {};
    setContacts(filter((item) => item.user_id != user?.user_id, users));
  }, []);

  useEffect(() => {
    getContacts();
  }, []);

  if (isEmpty(contacts)) return null;

  return <GroupeContacts title={t('filter.contacts')} users={take(3, contacts)} />;
}

export default Contacts;
